import {Service} from './index'

/**
 * WEB - [通用API] 查询当前商户信息
 * @export
 * @param {*} data
 * @return {*} 
 */
export function findShopItem(data) {
  return Service({
    url: '/amall_user/shop/findShopItem',
    method:"post",
    params: data
  })
} 
/**
 * WEB - [通用API] 查询当前商户销售区域
 * @export
 * @param {*} data
 * @return {*} 
 */
 export function findShopSalesarea(data) {
  return Service({
    url: '/amall_user/shop/findShopSalesarea',
    method:"post",
    params: data
  })
} 
/**
 * 总后台 - [商户管理] 编辑商户基本信息
 * @export
 * @param {*} data
 * @return {*}
 */
 export function updateShop(data) {
  return Service({
    url: '/amall_user/shop/updateShop',
    method:"post",
    data: data
  })
}
/**
 * 总后台-APPLET - [通用API] 省市级三级联动
 * @export
 * @param {*} data
 * @return {*} 
 */
 export function getPCD(data) {
  return Service({
    url: '/amall_user/user/getPCD',
    method:"post",
    params: data
  })
} 
/**
 * 总后台 - [商户管理] 编辑商户客服信息
 * @export
 * @param {*} data
 * @return {*} 
 */
 export function updateShopCustomerService(data) {
  return Service({
    url: '/amall_user/shop/updateShopCustomerService',
    method:"post",
    params: data
  })
} 
/**
 * PC - [余额支付] 商户发布大工程套餐开通 支付信息获取接口
 * @export
 * @param {*} data
 * @return {*} 
 */
 export function getReleasePayInfo(data) {
  return Service({
    url: '/amall_user/shop/getReleasePayInfo',
    method:"post",
    params: data
  })
} 
/**
 * PC - [余额支付] 工程结算商户余额支付
 * @export
 * @param {*} data
 * @return {*} 
 */
 export function shopBalancePay(data) {
  return Service({
    url: 'amall_user/shop/shopBalancePay',  
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    method: 'post',
    data: data
  })
}

/**
 * WEB - [通用API] 查询当前商户销售区域省份
 * @export
 * @param {*} data
 * @return {*} 
 */
 export function findOperateProvince(data) {
  return Service({
    url: '/amall_user/shop/findOperateProvince',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    method:"post",
    data: data
  })
} 

/**
 * WEB - [通用API] 查询当前商户销售区域市区
 * @export
 * @param {*} data
 * @return {*} 
 */
 export function newFindShopSalesarea(data) {
  return Service({
    url: '/amall_user/shop/findShopSalesarea',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    method:"post",
    data: data
  })
} 




// WEBPACK FOOTER //
// ./src/service/shop.js